function showStickyBar() {
    const stickyOfferBar = $('.stickyOfferBar');
    const scrollHeight = $(".heroContainer").height() + $(".newFranchiseHeader").height();

    if (stickyOfferBar.length > 0) {
        if ($(document).scrollTop() > scrollHeight) {
            stickyOfferBar.addClass("active");
        } else {
            stickyOfferBar.removeClass("active");
        }
    }
}

function scrollToEnquiry() {
    const stickyEnquire = $('.js_stickyEnquire');

    if (stickyEnquire.length > 0) {
        stickyEnquire.click(function() {
            $('html, body').animate({
                scrollTop: $(".topEnquire").offset().top - 100
            }, 500);
        });
    }
}

$(document).ready(function () {
    showStickyBar();
    scrollToEnquiry();

    $(window).scroll(function() {
        showStickyBar();
    });
});


